module.exports = __webpack_public_path__ + "static/bambini-119f9c540cfc2866a383408910e2b60c.jpg";